import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";

export default function GoogleMyBusinessAccess(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  const [userGrantAccess, setUserGrantAccess] = useState(
    props.teamAccess["Google Business"]["Full"] == "1" || props.teamAccess["Google Business"]["Restricted"] == "1"
  );
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if ((form.checkValidity() === true) && ((props.teamAccess["Google Business"]["Restricted"] === "1") || (props.teamAccess["Google Business"]["Full"] === "1"))) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });
  return (
    <>
      <Row className="mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Google Business Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will grant access to Google Business. Please check the box to indicate the access level granted. It's important to note that checking the access level boxes are solely for reference, and
              will not perform any actions in regards to granting access to your account.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="my-5 justify-content-center">
        <Col xl={4} lg={6}>
          <div>
            <p className="f14 light-primary">Complete as many of the below steps as possible, and check to confirm.</p>
          </div>
          <div className="p-4" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
            <div className="pb-2">
              <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
              <CustomFormCheck
                required
                id="ob_google_business_granted"
                name="google_business_granted"
                label="Google Business access granted"
                checked={userGrantAccess}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["Google Business"]["Restricted"] = props.teamAccess["Google Business"]["Restricted"] == "0" ? "0" : "1";
                  setUserGrantAccess(!userGrantAccess);
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
            <div className="pb-1">
              <p className="f14 visby-bold light-primary">Access level granted:</p>
            </div>
            <div className="pb-1 pl-3 ">
              <CustomFormCheck
                id="ob-google-merchant-full"
                name="google-merchant-full"
                label="Full"
                disabled={!userGrantAccess}
                checked={props.teamAccess["Google Business"]["Full"] == "1"}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["Google Business"]["Restricted"] = "0";
                  accessChecked["Google Business"]["Full"] = props.teamAccess["Google Business"]["Full"] == "1" ? "0" : "1";
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
            <div className="pb-1 pl-3">
              <CustomFormCheck
                id="ob-google-merchant-restricted"
                name="google-merchant-restricted"
                label="Restricted"
                disabled={!userGrantAccess}
                checked={props.teamAccess["Google Business"]["Restricted"] == "1"}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["Google Business"]["Full"] = "0";
                  accessChecked["Google Business"]["Restricted"] = props.teamAccess["Google Business"]["Restricted"] == "1" ? "0" : "1";
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
            <div>
              <p className="f12 pb-3 light-primary">
                Note: Google Business requires it's own specific process to grant access. Make sure to double-check with the client and other team members
                that all necessary steps have been taken, all necessary access are granted, and then check the box to confirm.
              </p>
            </div>
          </div>
        </Col>
        {/* <Col lg={4} className="mt-3">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/e1AvEHvOn1s"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ maxWidth: "100%" }}></iframe>
        </Col> */}
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
